<template>
  <!-- 详情弹窗只读 prompt：@image1 / 旧 [Image 1] token 渲染成
       「缩略图 + token + 底色」行内 chip（展示层转换，存储不动） -->
  <p class="mention-prompt">
    <template v-for="(seg, i) in segments" :key="i">
      <template v-if="seg.type === 'text'">{{ seg.value }}</template>
      <span v-else class="mp-chip">
        <video
          v-if="seg.kind === 'video' && seg.url"
          :src="seg.url"
          preload="metadata"
          muted
          playsinline
          class="mp-chip-thumb"
        />
        <img v-else-if="seg.kind === 'image' && seg.url" :src="seg.url" alt="" class="mp-chip-thumb" />
        <svg v-else-if="seg.kind === 'audio'" class="mp-chip-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
        </svg>
        <svg v-else-if="seg.kind === 'video'" class="mp-chip-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
        </svg>
        <svg v-else class="mp-chip-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>
        </svg>
        <span class="mp-chip-label">{{ seg.token }}</span>
      </span>
    </template>
  </p>
</template>

<script setup lang="ts">
import { splitByMentions, type MentionFormat } from '~/utils/seedanceMentions';

const props = defineProps<{
  prompt: string;
  imageUrls?: string[];
  videoUrls?: string[];
}>();

interface RenderSegment {
  type: 'text' | 'mention';
  value?: string;
  token?: string;
  kind?: MentionFormat;
  url?: string;
}

// token 序号 → 该记录素材列表里的 url（音频/缺失素材退回图标）
const segments = computed<RenderSegment[]>(() =>
  splitByMentions(props.prompt).map((seg) => {
    if (seg.type === 'text') return { type: 'text', value: seg.value };
    const m = seg.token.match(/^@(image|video|audio)(\d+)$/);
    const kind = m?.[1] as MentionFormat | undefined;
    const n = Number(m?.[2] ?? 0);
    const url =
      kind === 'image'
        ? props.imageUrls?.[n - 1]
        : kind === 'video'
          ? props.videoUrls?.[n - 1]
          : undefined;
    return { type: 'mention', token: seg.token, kind, url };
  }),
);
</script>

<style scoped>
.mp-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 2px;
  padding: 1px 6px;
  border-radius: 6px;
  background: rgba(217, 70, 239, 0.15); /* 主题色 15% 底，与创作页 chip 一致 */
  vertical-align: middle;
  font-weight: 500;
}
.mp-chip-thumb {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 3px;
  object-fit: cover;
}
.mp-chip-icon {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  color: #e879f9;
}
.mp-chip-label {
  color: #f0abfc; /* token 文字用主题强调色 */
}
</style>
